<template>
  <a-card title="Cálculo Situação">
    <form ref="form" @submit.prevent="submitForm">
      <div class="row">
        <div class="col-md-6">
          <label for="resultado">Resultado</label><label style="font-weight: bold; color: red">*</label>
          <div class="input-group input-focus select-height">
            <select class="form-select form-input-component" id="resultado" ref="resultado" v-model="registro.resultado" v-bind:class="{ 'is-invalid': submitted && !registro.resultado }">
              <option v-for="item in resultados" :key="item" :value="item">
                {{ item.descricao }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <a-divider type="horizontal" />

      <fieldset class="fieldset-custom">
        <legend style="width: 160px">Dados Cálculo</legend>
        <div class="row">
          <div class="col-md-4">
            <label for="cpf">Faixa etária</label><label style="font-weight: bold; color: red">*</label>
            <div class="input-group input-focus">
              <select class="form-select form-input-component" ref="faixasEtarias" v-bind:class="{ 'is-invalid': submittedCalculo && !calculo.faixaEtaria }" v-model="calculo.faixaEtaria">
                <option v-for="item in faixasEtarias" :key="item" :value="item">
                  {{ item.nome }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-8">
            <label for="nome">Condição</label><label style="margin-left: 1px; font-weight: bold; color: red">*</label>
            <br />
            <input v-model="calculo.condicao" type="text" class="form-control form-input-component" v-bind:class="{ 'is-invalid': submittedCalculo && !calculo.condicao }" />
          </div>
        </div>
        <div class="row" style="margin-top: 8px">
          <div class="col-md-4">
            <label for="nome">NF = Nota do Exercício Flexão.</label>
          </div>
          <div class="col-md-4">
            <label for="nome">NA = Nota do Exercício Abdominal.</label>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <label for="nome">NC = Nota do Exercício Corrida.</label>
          </div>

          <div class="col-md-4">
            <label for="nome">NB = Nota do Exercício Barra.</label>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <label for="nome">RM = Resultado da Média do TAF.</label>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <label for="nome">OU = Operador para pelo menos um valor verdadeiro.</label>
          </div>
          <div class="col-md-4">
            <label for="nome">E = Operador para todos valores verdadeiros.</label>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <br />
            <button type="button" class="btn btn-primary" @click="selecionarItem">Incluir</button>
          </div>
        </div>
        <br />
        <div class="row" v-show="registro.calculos.length > 0">
          <div class="col-md-8">
            <a-table :dataSource="registro.calculos" :columns="columns">
              <template #action="{ record }">
                <a title="Editar" @click="editarItem(record)"><i class="fas fa-edit icon-edit"></i></a>&nbsp;
                <a title="Opções" @click="removerItem(record)"><i class="fas fa-trash icon-trash"></i></a>
              </template>
            </a-table>
          </div>
        </div>
      </fieldset>

      <a-divider type="horizontal" />
      <div class="spaced-container">
        <button type="submit" class="btn btn-primary" @click="cadastrar()">Salvar</button>
        <button class="btn btn-warning" @click="voltar">Voltar</button>
      </div>
    </form>
  </a-card>
</template>

<script>
import { openNotification, typesNotification } from '@/utils/notifications';
import { create, getById } from '@/components/service/parametroTafCalculoSituacaoService';
import { getFaixasExtarias } from '@/components/service/faixaEtariaService';
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { EnumResultadoAR } from '@/components/models/enumResultadoAR';
export default {
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      especialidades: [],
      especialidadesFiltro: [],
      resultados: EnumResultadoAR(),
      selecionarNome: '',
      nomeSelecionado: null,
      idSelecionado: null,
      submitted: false,
      submittedCalculo: false,
      faixasEtarias: [],
      registro: {
        calculos: [],
      },
      calculoEditar: null,
      calculo: {
        condicao: undefined,
        faixaEtaria: undefined,
      },

      columns: [
        {
          title: '',
          dataIndex: 'identificador',
          key: 'identificador',
          slots: { customRender: 'identificador' },
        },
        {
          title: 'Faixa Etária',
          dataIndex: 'faixaEtaria.nome',
          key: 'faixaEtaria.nome',
          slots: { customRender: 'faixaEtaria' },
        },
        {
          title: 'Condição',
          dataIndex: 'condicao',
          key: 'condicao',
          slots: { customRender: 'condicao' },
        },
        {
          title: 'Ações',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
      ],
    };
  },
  validations() {
    return {
      registro: {
        resultado: {
          required,
        },
      },
      calculo: {
        condicao: {
          required,
        },
        faixaEtaria: {
          required,
        },
      },
    };
  },
  methods: {
    async cadastrar() {
      if (this.v$.registro.$invalid) {
        this.submitted = true;
        openNotification(typesNotification.warning, 'Informe os campos obrigatórios!');
      } else if (this.registro.calculos.length == 0) {
        openNotification(typesNotification.warning, 'Você deve incluir pelo menos um cálculo para cadastrar o resultado!');
      } else {
        let registroPost = { ...this.registro };
        await create(registroPost).then(() => {
          if (!this.registro.id) {
            openNotification(typesNotification.success, 'Dados salvos com sucesso.');
          } else {
            openNotification(typesNotification.success, 'Dados alterados com sucesso.');
          }
          this.itensSelecionados = [];
          this.submitted = false;
          this.registro = { calculos: [] };
        });
      }
    },
    removerItem(record) {
      const index = this.registro.calculos.indexOf(record);
      if (index > -1) {
        this.registro.calculos.splice(index, 1);
        this.registro.calculos.forEach((c, index) => {
          c.identificador = index + 1;
        });
      }
    },
    selecionarItem() {
      if (!this.v$.calculo.$invalid) {
        if (this.calculoEditar != null) {
          this.registro.calculos.splice(
            this.registro.calculos.findIndex((obj) => obj.identificador === this.calculoEditar.identificador),
            1,
            this.calculo
          );
        } else {
          this.calculo.identificador = this.registro.calculos.length + 1;
          this.registro.calculos.push(this.calculo);
        }
        this.calculo = {};
        this.calculoEditar = null;
        this.submittedCalculo = false;
      } else {
        this.submittedCalculo = true;
        openNotification(typesNotification.warning, 'Preencha os dados do cálculo!');
      }
    },
    editarItem(record) {
      this.calculo = { ...record };
      this.calculoEditar = { ...record };
    },
    voltar() {
      this.$router.go(-1);
    },
    async carregar() {
      if (this.$route.query.id) {
        const idUrl = this.$route.query.id;
        const res = await getById(idUrl);
        this.registro = { ...res.data, id: idUrl };
      }
    },
  },
  async created() {
    let reponse = await getFaixasExtarias();
    Object.assign(this.faixasEtarias, reponse.data);
    console.log(this.faixasEtarias);
    this.carregar();
  },
};
</script>

<style>
.input-group-text {
  height: 38px;
}

.input-group-prepend {
  cursor: pointer;
  margin-left: 8px !important;
}

.input-group-text:hover {
  background-color: #e0e0e0 !important;
}

.h2 {
  font-size: x-large;
}

.spaced-container * {
  margin-top: 10px;
  margin-right: 10px;
}
</style>
